<template lang="pug">
#bloco-tabs-mapa-monitoramento-agricola
    .bloco-tabs
        el-tabs.bloco-tabs-dimensao(
            :tab-position='tabPosition',
            v-model='culturaSelecionada',
            @tab-click='onChangeCultura'
        )
            el-tab-pane(
                name='ALGODAO',
                :disabled='culturasExistentes.filter(c => c.codigo.includes("ALGODAO")).length === 0'
            )
                span.bloco-tabs-dimensao-menu(slot='label')
                    i.lyra-icon.lyra-algodao
                    | {{ $t('mensagens.cultura.ALGODAO').toUpperCase() }}

            el-tab-pane(
                name='CANA',
                :disabled='culturasExistentes.filter(c => c.codigo.includes("CANA")).length === 0'
            )
                span.bloco-tabs-dimensao-menu(slot='label')
                    i.lyra-icon.lyra-cana
                    | {{ $t('mensagens.cultura.CANA').toUpperCase() }}

            el-tab-pane(
                name='MILHO',
                :disabled='culturasExistentes.filter(c => c.codigo.includes("MILHO")).length === 0'
            )
                span.bloco-tabs-dimensao-menu(slot='label')
                    i.lyra-icon.lyra-milho
                    | {{ $t('mensagens.cultura.MILHO').toUpperCase() }}

            el-tab-pane(
                name='SOJA',
                :disabled='culturasExistentes.filter(c => c.codigo.includes("SOJA")).length === 0'
            )
                span.bloco-tabs-dimensao-menu(slot='label')
                    i.lyra-icon.lyra-soja
                    | {{ $t('mensagens.cultura.SOJA').toUpperCase() }}

            el-tab-pane(
                name='TRIGO',
                :disabled='culturasExistentes.filter(c => c.codigo.includes("TRIGO")).length === 0'
            )
                span.bloco-tabs-dimensao-menu(slot='label')
                    i.lyra-icon.lyra-trigo
                    | {{ $t('mensagens.cultura.TRIGO').toUpperCase() }}

            el-tab-pane(
                name='OUTROS',
                :disabled='culturasExistentes.filter(c => c.codigo.includes("OUTROS")).length === 0'
            )
                span.bloco-tabs-dimensao-menu(slot='label')
                    i.lyra-icon.lyra-outros
                    | OUTROS
        div(:class="culturaSelecionada === 'SOJA' ? 'bloco-tabs-conteudo' : 'bloco-tabs-conteudo-culturas'" v-if='culturasExistentes.length')
            DadosTabs(:dados='dadosMonitoramento')

        div(:class="culturaSelecionada === 'SOJA' ? 'bloco-tabs-conteudo' : 'bloco-tabs-conteudo-culturas'" class="bloco-sem-dados" v-else)
            empty-result(
                :min-height='150',
                icon-class='mdi-alert-octagon',
                :message="$t('mensagens.monitoramentoAgricola.visualizarImovel.naoHaDadosMonitoramentoParaVisualizacao')"
            )

    div(:class="culturaSelecionada === 'SOJA' ? 'bloco-mapa' : 'bloco-mapa-cultura'")
        Mapa(
            ref='mapa',
            height='100%',
            idMapa='mapaMonitoramentoAgricola',
            :key='keyMapa',
            :mapLayersConfigs='camadasMapa',
            :mapConfig='configuracoesMapa'
        )
        .checkbox-camada
            el-checkbox(
                :label="$t('mensagens.monitoramentoAgricola.visualizarImovel.visualizarAreaPlantada')",
                class="checkbox-camada-bottom"
                v-model='camadaAtiva',
                @change='atualizarGeometriaAreaPlantada'
            )

</template>

<script>
import Mapa from '@/components/MapaLeaflet';
import DadosTabs from '@/components/monitoramento/BlocoDadosTabsMapaMonitoramentoAgricola';
import { CULTURAS } from '@/utils/TipoCultura';
import LayerStyle, { getEstiloCultura } from '../../utils/layerStyles';
import EmptyResult from '../EmptyResult.vue';

import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';
import formatters from '@/utils/formatters';
import EventBus from '@/utils/eventBus';

import { CodigoAcuracia } from '../../constants/AcuraciaEnum';

export default {
    name: 'BlocoTabsMapaMonitoramentoAgricola',
    components: {
        Mapa,
        DadosTabs,
        EmptyResult
    },
    props: {
        monitoramento: {
            type: Object,
            required: true,
            default: () => null
        },
        monitoramentoAgro: {
            type: Object,
            required: true,
            default: () => null
        },
        dadosPlantio: {
            type: Object,
            required: true,
            default: () => null
        }
    },

    data() {
        return {
            idAreaMonitorada: this.$route.params.id,
            camadasMapa: null,
            configuracoesMapa: {
                controls: {
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true,
                    ferramentasControl: false
                }
            },
            dadosMonitoramento: {
                culturaSelecionada: '',
                dataInicioPlantio: '-',
                dataPrevisaoColheita: '-',
                areaPlantada: 0,
                areaColhida: 0,
                produtividadeInformada: 0,
                produtividadeMonitorada: 0,
                evolucaoArea: {
                    colhido: '0% colhido(0 ha)',
                    pendente: '100% não colhido(0 ha)'
                }
            },

            keyMapa: 100,
            camadaCentralizadaNome: null,
            tabPosition: 'left',
            culturasExistentes: [],
            culturaSelecionada: 'ALGODAO',
            dadosMonitoramentoCultura: [],
            camadaAtiva: true,
            alturaConteudo:
                this.culturasExistentes === 'OUTROS' ? '550px' : 'fit-content'
        };
    },

    async mounted() {
        await this.filtraCulturasExistentes();
    },

    methods: {
        async filtraCulturasExistentes() {
            try {
                let culturas =
                    this.monitoramentoAgro.monitoramentosConfirmacaoCultura.map(
                        m => m.cultura
                    );
                culturas.push(this.monitoramento.culturaEsperada);

                culturas = _.flatMap(
                    _.uniqBy(culturas, function (e) {
                        return e.codigo;
                    }),
                    e => {
                        return e;
                    }
                );

                this.culturasExistentes = [
                    ...culturas.sort((a, b) => (a.codigo > b.codigo ? 1 : -1))
                ];

                const cultasSequencia = [
                    'SOJA',
                    'MILHO',
                    'TRIGO',
                    'ALGODAO',
                    'CANA',
                    'OUTROS'
                ];

                let primeiroNaSequencia = null;

                for (let codigo of cultasSequencia) {
                    const cultura = this.culturasExistentes.find(
                        item => item.codigo === codigo
                    );
                    if (cultura) {
                        primeiroNaSequencia = cultura;
                        break;
                    }
                }
                this.culturaSelecionada = primeiroNaSequencia.codigo;
                this.onChangeCultura();
            } finally {
                this.atualizarDadosFiltrados();
            }
        },

        atualizarDadosFiltrados() {
            try {
                this.dadosMonitoramento.culturaSelecionada = this.culturaSelecionada;

                const areaPlantada = this.montaDadosAreaPlantada();

                const areaColhida = this.montaDadosAreaColhida();

                const datasPlantio = this.montaDadosPlantio();

                this.dadosMonitoramento = {
                    ...this.dadosMonitoramento,

                    ...datasPlantio,
                    areaPlantada,
                    areaColhida,

                    produtividadeInformada:
                        this.monitoramento.culturaEsperada.codigo ===
                        this.culturaSelecionada
                            ? this.monitoramento.produtividadeEsperadaScHa
                            : 0,

                    produtividadeMonitorada:
                        this.montaDadosProdutividadeEstimada(),

                    evolucaoArea: this.montaEvolucaoColheita(
                        areaPlantada,
                        areaColhida
                    )
                };
            } finally {
                this.atualizarGeometriaAreaPlantada();
            }
        },

        atualizarGeometriaAreaPlantada() {
            this.configureLayersMapa();

            if (this.camadaAtiva === true) {
                this.dadosMonitoramentoCultura.forEach(dados => {
                    let codigoEstilo = '';
                    if (dados.cultura.codigo === 'SOJA') {
                        codigoEstilo = dados.codigoAcuracia;
                    } else {
                        codigoEstilo = dados.cultura.codigo;
                    }

                    const estilo =
                        getEstiloCultura(CULTURAS[codigoEstilo]) ||
                        LayerStyle.AREA_PLANTADA();

                    let layerAreaCultura = {
                        style: estilo,
                        name: dados.cultura.nome,
                        geoJson: dados.geometria
                    };
                    this.camadasMapa.push(layerAreaCultura);
                });
            }
        },

        configureLayersMapa() {
            this.camadasMapa = [];

            let layerAreaMonitorada = {
                style: getEstiloGeometria('area'),
                name: 'Área Monitorada',
                geoJson: this.monitoramento.geometria,
                featureGroup: true
            };

            this.camadasMapa.push(layerAreaMonitorada);
        },

        montaDadosPlantio() {
            const datasEstimadaPlantio = [
                this.dadosPlantio.areasPlantadas
                    .filter(c => c.cultura !== null && c.cultura.codigo === this.culturaSelecionada)
                    .map(p => {
                        let dataString = p.dataEstimadaPlantio.split('/');
                        return new Date(
                            dataString[2],
                            dataString[1] - 1,
                            dataString[0]
                        );
                    })
            ];

            const dataEstimadaPlantio = _.flatMap(
                _.uniqBy(datasEstimadaPlantio, function (e) {
                    return e;
                }),
                e => {
                    return e;
                }
            )
                .sort((a, b) => (a > b ? 1 : -1))
                .at(0);

            if (dataEstimadaPlantio) {
                const prazoColheita = this.culturasExistentes
                    .filter(c => c.codigo === this.culturaSelecionada)
                    .at(0).prazoColheita;

                const dataInicioPlantio =
                    dataEstimadaPlantio.toLocaleDateString('pt-BR', {
                        timeZone: 'UTC'
                    });

                const dataPrevisaoColheita = new Date(
                    dataEstimadaPlantio.setDate(
                        dataEstimadaPlantio.getDate() + prazoColheita
                    )
                );

                return {
                    dataInicioPlantio: dataInicioPlantio,
                    dataPrevisaoColheita:
                        dataPrevisaoColheita.toLocaleDateString('pt-BR', {
                            timeZone: 'UTC'
                        })
                };
            }
            return {
                dataInicioPlantio: '-',
                dataPrevisaoColheita: '-'
            };
        },

        montaDadosAreaPlantada() {
            const areas = [
                ...this.monitoramentoAgro.monitoramentosConfirmacaoCultura.filter(
                    d => d.cultura.codigo === this.culturaSelecionada
                )
            ];

            this.dadosMonitoramentoCultura = [...areas];

            return areas.map(h => h.areaHa).reduce((a, b) => a + b, 0);
        },

        montaDadosAreaColhida() {
            const areaColhidaFiltrada = [
                ...this.monitoramentoAgro.monitoramentosColheita.filter(
                    d => d.cultura.codigo === this.culturaSelecionada
                )
            ];

            return areaColhidaFiltrada
                .map(h => h.areaHa)
                .reduce((a, b) => a + b, 0);
        },

        montaDadosProdutividadeEstimada() {
            const produtividadeEstimadaFiltrada = [
                ...this.monitoramentoAgro.monitoramentosProdutividadeEstimada.filter(
                    d => d.cultura.codigo === this.culturaSelecionada
                ).map(p => {
                    return {
                        ...p,
                        dataProcessamento: Date.parse(p.dataProcessamento)
                    };
                })
            ].sort((a, b) => {
                return a.dataProcessamento - b.dataProcessamento;
            });
            
            if (produtividadeEstimadaFiltrada.length === 0) {
                return 0;
            }

            const agrupadosPorData = produtividadeEstimadaFiltrada.reduce((acc, curr) => {
                acc[curr.dataProcessamento] = [...(acc[curr.dataProcessamento] || []), curr];
                return acc;
            }, {});

            const ultimasProdutividades = Object.values(agrupadosPorData).map(group => {
                return group.reduce((max, curr) => (curr.id > max.id ? curr : max));
            });

            const ultimaProdutividade = ultimasProdutividades.slice(-1)[0];

            return ultimaProdutividade.produtividade;
        },

        montaEvolucaoColheita(areaPlantada, areaColhida) {
            areaPlantada = Number(Number(areaPlantada).toFixed(3));
            areaColhida = Number(Number(areaColhida).toFixed(3));

            let percentualColhido = isFinite(areaColhida / areaPlantada)
                ? (areaColhida / areaPlantada) * 100
                : 0;

            let percentualPendente = percentualColhido === 0 ? 0 : 100 - percentualColhido;

            percentualPendente = Math.max(percentualPendente, 0);

            let areaPendente =
                areaPlantada - areaColhida > 0.0
                    ? areaPlantada - areaColhida
                    : 0;

            percentualColhido = formatters.formatNumber(percentualColhido, 0);
            percentualPendente = formatters.formatNumber(percentualPendente, 0);
            areaPendente = formatters.formatNumber(areaPendente, 2);
            areaColhida = formatters.formatNumber(areaColhida, 2);

            return {
                colhido: `${percentualColhido}%  colhido (${areaColhida} ha)`,
                pendente: `${percentualPendente}%  não colhido (${areaPendente} ha)`,
                percentualColhido: Number(percentualColhido)
            };
        },

        onChangeCultura() {
            let listaCodigosAcuracia = [];
            if (this.culturaSelecionada === 'SOJA') {
                listaCodigosAcuracia = [CodigoAcuracia.ACURACIA80, CodigoAcuracia.ACURACIA51A80, CodigoAcuracia.ACURACIA50];
            } else {
                listaCodigosAcuracia = [this.culturaSelecionada];
            }
            EventBus.$emit('emit-change-cultura', listaCodigosAcuracia, this.culturaSelecionada);
            this.atualizarDadosFiltrados();
        }
    }
};
</script>

<style lang="scss">
#bloco-tabs-mapa-monitoramento-agricola {
    display: flex;
    justify-content: space-between;

    .bloco-tabs {
        width: 49.25%;
        display: flex;
        order: 0;
        padding-right: 12px;

        .bloco-tabs-dimensao {
            height: 100%;
            overflow: initial;
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;

            .bloco-tabs-dimensao-menu {
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                height: 100%;
                align-items: center;
            }
        }

        .bloco-tabs-conteudo {
            height: v-bind(alturaConteudo);
            width: 100%;
            background: var(--white);
            box-shadow: 0px 0px 20px rgb(0 0 0 / 10%);
            border-radius: 5px;
            padding: 10px 15px;
        }

        .bloco-tabs-conteudo-culturas {
            height: 406px;
            width: 100%;
            background: var(--white);
            box-shadow: 0px 0px 20px rgb(0 0 0 / 10%);
            border-radius: 5px;
            padding: 10px 15px;
        }

        .el-tabs__item {
            text-align: center !important;
            background: var(--white);
            box-shadow: 0px 0px 10px rgb(0 0 0 / 10%);
            border-radius: 5px;
            margin-bottom: 9px;
            font-weight: 600;
            height: 60px;
            line-height: 17px !important;
            padding: 5px 10px;

            .lyra-icon::before {
                background-color: var(--primary);
                width: 19px !important;
                height: 19px !important;
            }

            &.is-active:not(.is-disabled) {
                .lyra-icon::before {
                    background-color: var(--white) !important;
                }
            }
            &.is-disabled {
                .lyra-icon::before {
                    background-color: var(--background-disabled) !important;
                }
            }
        }

        .el-tabs__item.is-active:not(.is-disabled) {
            color: var(--white) !important;
            background: var(--secondary-two) !important;
        }
        .el-tabs__nav-wrap::after {
            content: '';
            background-color: var(--default-background-color) !important;
        }
        .el-tabs__active-bar {
            display: none;
        }
    }

    .bloco-mapa {
        width: 49.25%;
        height: 517px;
        border-radius: 5px;
        overflow: hidden;
        box-shadow: 0px 1px 5px 0px var(--block-shadow);
    }

    .bloco-mapa-cultura {
        width: 49.25%;
        height: 406px;
        border-radius: 5px;
        overflow: hidden;
        box-shadow: 0px 1px 5px 0px var(--block-shadow);
    }

}

.bloco-sem-dados {
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>

<style lang="scss" scoped>
.bloco-mapa {
    .el-tabs__item.is-active:not(.is-disabled) {
        color: var(--white) !important;
        background: var(--secondary-two) !important;
    }
    .el-tabs__nav-wrap::after {
        content: '';
        background-color: var(--default-background-color) !important;
    }
    .el-tabs__active-bar {
        display: none;
    }
    .checkbox-camada {
        position: relative;
        z-index: 9999;
        bottom: 98%;
        left: 1%;
        background-color: white;
        width: fit-content;
        padding: 2px 6px 2px 6px;
        border-radius: 5px;
    }
    .checkbox-camada-bottom {
        margin-bottom: 0 !important;
    }
}
</style>
